<template>
  <el-scrollbar ref="scrollbar" class="page_main_height">
    <el-row class="new_info">
      <div class="big_screen">
        <index_head />

        <div class="main" :style="'background-image: url(' + filePath + '/nemojoyWebSiteFile/imgs/news/new_bac1.jpg); background-repeat: no-repeat; background-position: top right; background-size: 100%;'">
          <div class="new_main">
            <div class="new_info_head">
              <div class="head_date center text">
                <i class="el-icon-date date_icon" />
                {{ new_info.rt }}
              </div>
              <div class="head_main center">
                {{ new_info.n }}
              </div>
            </div>
            <div class="new_info_main">
              <el-row class="info_text" v-html="new_info.t" />
            </div>
          </div>
        </div>

        <index_bottom />
      </div>

      <div class="small_screen">
        <h2 class="new_info_head">{{ new_info.c }}</h2>
        <el-row class="new_info_text" v-html="new_info.t" />
      </div>
    </el-row>
  </el-scrollbar>
</template>

<script>
import { get_news_data_page } from '@/api/news'
import vv from '@/components/varVariable'

export default {
  name: 'NewInfo',
  data: function() {
    return {
      new_info: {},
      config: {}
    }
  },
  computed: {
    filePath() {
      return vv.fileHttp
    }
  },
  created() {
    const new_id = this.$route.query.id
    get_news_data_page({ id: new_id }).then(d => {
      const data = d.d
      if (data) {
        this.new_info = data[0]
        /* HH:mm:ss*/
        this.new_info.rt = this.$moment(new Date(this.new_info.rt)).format('YYYY-MM-DD')
      }
    })
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

@media screen and (max-width: 768px){
  .big_screen{
    display: none!important;
  }

  .small_screen{
    display: block!important;
    width: 100vw;
    height: 100vh;
  }

  .el-scrollbar__wrap{
    overflow-x: hidden!important;
  }
}

/*大于768px的显示*/
@media screen and (min-width: 768px){
  .big_screen{
    width: 100vw;
    height: 100vh;
  }

  .small_screen{
    display: none!important;
  }
}

.new_info{
  width: 100vw;
  min-height: 100vh;

  .big_screen{
    padding-top: 84px;

    .center{
      display: flex;
      justify-content: center;
    }

    .index_pc_head{
      background-image: linear-gradient( to right, #000000, rgba(0, 0, 0, .58)) !important;
    }

    .main{
      width: 100%;
      min-height: calc(100vh - 294px);

      .new_main{
        width: 80%;
        margin: auto;

        .new_info_head{
          width: 100%;
          height: 300px;
          display: flex;
          flex-direction: column-reverse;

          .head_main{
            width: 100%;
            color: #FFFFFF;
            font-size: 34px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
          }

          .head_date{
            width: 100%;
            color: #A8A9AB;
            display: flex;
            align-items: center;
            margin-top: 19px;
            margin-bottom: 30px;
            font-weight: bold;

            .date_icon{
              color: #E6634E;
              margin-right: 5px;
            }
          }
        }

        .new_info_main{
          padding-top: 87px;
        }
      }
    }
  }

  .small_screen{
    width: 100%;
    padding: 0.2rem;

    .new_info_head{
      width: 100%;
      display: flex;
      justify-content: center;
    }

    .new_info_text{
      line-height: .25rem;
    }
  }
}
</style>
